import React, { useEffect, useState } from 'react'
import { updateModal, getCompCityList } from '../../../../../store/common/common_action'
import { connect } from 'react-redux'
import * as mdt from '../../../../common/modaltypes'
import { Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material'
import { XMarkSvg } from '../../../../common/svg/xMark'
import { CheckMarkSvg } from '../../../../common/svg/checkMark'
import EditIcon from '@mui/icons-material/Edit'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { focusElemnt, isEmpty, navigation1, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import AutoReceiveModal from './AutoReceiveModal'
import { getAutoReceiveTableData, autoReceiveDataInsertUpdate } from '../../../../../store/generalSetting/GSAction'
import moment from 'moment'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import { getOwnChildBranches, getOwnChildUsers } from '../../../../../store/reports/reports_action'
const AutoReceiveTable = (props) => {
    const { data, updateModal, getOwnChildBranches, getOwnChildUsers, getCompCityList, getAutoReceiveTableData } = props
    const { common, generalSettingReducer, reports } = data
    const { loginData, roleRights, showModal, modalType, companyCityList } = common
    const { autoReceiveTableData } = generalSettingReducer
    const { ownChildBranches, ownChildUsers } = reports
    const [tableData, setTableData] = useState([])
    const [filterValues, setFilterValues] = useState({});
    const [filteredData, setfilteredData] = useState(tableData)
    const [editData, setEditData] = useState({})
    const [isSuccess, setIsSuccess] = useState(false)
    const [branchList, setBranchList] = useState([])
    const [userList, setUserList] = useState([])
    const [cityList, setCityList] = useState([])
    const [daysList, setDaysList] = useState([])
    const [hoursList, setHoursList] = useState([])
    const [minsList, setMinsList] = useState([])
    const [message, setMessage] = useState('New Auto Receive Config.\n Saved Successfully!')
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }

    useEffect(() => {
        focusElemnt('arNewAutoRecv')
    }, [])

    useEffect(() => {
        getTableData()
    }, [loginData])

    const getTableData = () => {
        if (!isEmpty(loginData)) {
            let object = {
                CompanyID: loginData?.intCompanyID
            }
            getAutoReceiveTableData(object)
        }
    }
    useEffect(() => {
        //branchList
        if (!isEmpty(loginData)) {
            const branchData = {
                intUserID: 0,
                intCompanyID: loginData?.intCompanyID,
                intIsActive: 1,
            }
            getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)

            //userList
            const userData = {
                intCompanyID: loginData.intCompanyID,
                intIsActive: 1,
            }
            getOwnChildUsers(userData, true, 24 * 60 * 60 * 1000)
            //cityList
            const cityObj = {
                intCompanyID: loginData.intCompanyID,
                intBranchID: 0,
                intUserID: 0,
            }
            getCompCityList(cityObj, true, 24 * 60 * 60 * 1000)
        }
        var days = [];
        for (let i = 0; i < 8; i++) {
            let val = i === 1 ? `${i} Day` : `${i} Days`;
            days[i] = { id: i, name: val };
        }
        setDaysList(days);
        var hours = [];
        for (let i = 0; i < 24; i++) {
            let val = i === 1 ? `${i} Hour` : `${i} Hours`;
            hours[i] = { id: i, name: val };
        }
        setHoursList(hours);
        var mins = [];
        for (let i = 0; i < 60; i++) {
            let val = i === 1 ? `${i} Min.` : `${i} Mins.`;
            mins[i] = { id: i, name: val };
        }
        setMinsList(mins);
    }, [loginData])

    useEffect(() => {
        if (companyCityList?.length > 0) {
            var cities = [{ id: 0, name: 'All' }]
            companyCityList.map(function (obj) {
                cities.push({
                    id: obj.CityID,
                    name: obj.CityName,
                })
            })
            cities = removeDuplicatesFromArray(cities, `id`)
            cities.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
            setCityList(cities)
        }
    }, [companyCityList])

    useEffect(() => {
        if (ownChildBranches?.length > 0) {
            var branches = []
            ownChildBranches.map(function (obj) {
                branches.push({
                    id: obj.BranchID,
                    name: obj.BranchName,
                    city: obj.CityID
                })
            })
            branches = removeDuplicatesFromArray(branches, `id`)
            branches.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
            setBranchList(branches)
        }
    }, [ownChildBranches])

    useEffect(() => {
        if (ownChildUsers?.length > 0) {
            var users = []
            ownChildUsers.map(function (obj) {
                users.push({
                    id: obj.UserID,
                    name: obj.UserName,
                    branch: obj.BranchID
                })
            })
            users = removeDuplicatesFromArray(users, `id`)
            users.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
            setUserList(users)
        }
    }, [ownChildUsers])

    useEffect(() => {
        if (autoReceiveTableData?.length > 0) {
            const data = [...autoReceiveTableData]
            data.sort((a, b) => {
                const cityComparison = a.CityName.localeCompare(b.CityName);
                if (cityComparison !== 0) {
                    return cityComparison;
                }
                return a.BranchName.localeCompare(b.BranchName);
            });
            let newData = data?.map((val, i) => ({ ...val, DaysValue: `${val.Days} ${val.Days === 1 ? 'Day' : 'Days'}`, HoursValue: `${val.Hours} ${val.Hours === 1 ? 'Hour' : 'Hours'}`, MinutesValue: `${val.Minutes} ${val.Minutes === 1 ? 'Minute' : 'Minutes'}` }))
            setTableData(newData)
        } else {
            setTableData([])
        }
    }, [autoReceiveTableData])

    useEffect(() => setfilteredData(tableData), [tableData])

    useEffect(() => {
        const filteredDataTemp = tableData.filter((item) => {
            return columnDefs.every((column) => {
                const filterValue = filterValues[column.field] || "";
                const value = item[column.field]?.toString()
                return filterValue ? value && value.toString().toLowerCase().includes(filterValue.toLowerCase()) : true
            })
        })
        setfilteredData(filteredDataTemp)
    }, [filterValues])
    const handleChangeContain = (e, name) => {
        let value = e.target.value;
        setFilterValues((prevFilterValues) => ({
            ...prevFilterValues,
            [name]: value
        }));
    }
    const columnDefs = [
        { headerName: 'S/N', headerSx: { padding: "6px 12px", textAlign: 'right', minWidth: "4%" }, field: "SN", dataType: "string", showfilter: false, allowSorting: false },
        { headerName: 'Auto Receive\n By City', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "9%" }, field: "CityName", dataType: "string", showfilter: true, allowSorting: false },
        { headerName: 'Auto Receive\n By Branch', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "12%" }, field: "BranchName", dataType: "string", showfilter: true, allowSorting: false },
        { headerName: 'Auto Receive\n By User', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "9%" }, field: "UserName", dataType: "time", showfilter: true, allowSorting: false },
        { headerName: 'Auto Receive\n After Days', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "9%" }, field: "DaysValue", dataType: "string", showfilter: true, allowSorting: false },
        { headerName: 'Auto Receive\n After Hours', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "12%" }, field: "HoursValue", dataType: "string", showfilter: true, allowSorting: false },
        { headerName: 'Auto Receive\n After Minutes', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "9%" }, field: "MinutesValue", dataType: "string", showfilter: true, allowSorting: false },
        { headerName: 'Status', headerSx: { padding: "6px 12px", textAlign: 'center', minWidth: "5%" }, field: "IsActive", dataType: "string", showfilter: false, allowSorting: false },
        { headerName: 'Modified By\n User', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "9%" }, field: "ModifiedByUser", dataType: "string", showfilter: true, allowSorting: false },
        { headerName: 'Modified Date\n and Time', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "9%" }, field: "ModifiedDateTime", dataType: "string", showfilter: false, allowSorting: false },
        { headerName: 'Edit', headerSx: { padding: "6px 12px", textAlign: 'left', minWidth: "4%" }, field: "Edit", dataType: "string", showfilter: false, allowSorting: false },
    ]

    const EmptyTableRow = () => {
        return (
            <TableRow>
                <TableCell key='empty-tbl-cell' colSpan={11}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '15px',
                            marginBottom: '15px',
                            color: 'red',
                            fontSize: '14px',
                        }}
                    >
                        <span>No results found.</span>
                    </div>
                </TableCell>
            </TableRow>
        )
    }
    const AutoReceiveRow = (props) => {
        const { item, index } = props
        return (
            <TableRow key={`auto-recv-${index}`} style={{ minHeight: '36px' }}>
                <TableCell key={`ar-${index}-SN`} style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '4%', padding: '4px 8px', textAlign: 'right' }}> {index + 1} </TableCell>
                <TableCell key={`ar-${index}-CityName`} style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '9%', padding: '4px 8px', maxWidth: '120px' }}>
                    <Tooltip title={`${item.CityName}`}
                        PopperProps={{
                            sx: {
                                "& .MuiTooltip-tooltip": {
                                    backgroundColor: '#DAEDFE',
                                    color: "#000",
                                    minHeight: '26px',
                                    display: 'flex',
                                    fontWeight: '400',
                                    alignItems: "center",
                                    marginTop: '5px !important',
                                    fontSize: '12px'
                                }
                            }
                        }}
                        placement="bottom-start">
                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline' }}>
                            {item.CityName}
                        </span>
                    </Tooltip>
                </TableCell>
                <TableCell key={`ar-${index}-BranchName`} style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '12%', padding: '4px 8px', maxWidth: '160px' }}>
                    <Tooltip title={`${item.BranchName}`}
                        PopperProps={{
                            sx: {
                                "& .MuiTooltip-tooltip": {
                                    backgroundColor: '#DAEDFE',
                                    color: "#000",
                                    minHeight: '26px',
                                    display: 'flex',
                                    fontWeight: '400',
                                    alignItems: "center",
                                    marginTop: '5px !important',
                                    fontSize: '12px'
                                }
                            }
                        }}
                        placement="bottom-start">
                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline' }}>
                            {item.BranchName}
                        </span>
                    </Tooltip>

                </TableCell>
                <TableCell key={`ar-${index}-UserName`} style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '9%', padding: '4px 8px', maxWidth: '120px' }}>
                    <Tooltip title={`${item.UserName}`}
                        PopperProps={{
                            sx: {
                                "& .MuiTooltip-tooltip": {
                                    backgroundColor: '#DAEDFE',
                                    color: "#444",
                                    minHeight: '26px',
                                    display: 'flex',
                                    fontWeight: '400',
                                    alignItems: "center",
                                    marginTop: '5px !important',
                                    fontSize: '12px'
                                }
                            }
                        }}
                        placement="bottom-start">
                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline' }}>
                            {item.UserName}
                        </span>
                    </Tooltip>
                </TableCell>
                <TableCell key={`ar-${index}-Days`} style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '9%', padding: '4px 8px' }}>{item.DaysValue}</TableCell>
                <TableCell key={`ar-${index}-Hours`} style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '12%', padding: '4px 8px' }}> {item.HoursValue}</TableCell>
                <TableCell key={`ar-${index}-Mins`} style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '9%', padding: '4px 8px' }}> {item.MinutesValue}</TableCell>
                <TableCell key={`ar-${index}-Status`} style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '5%', padding: '4px 8px', textAlign: 'center' }}>
                    {item.IsActive ?
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                            <CheckMarkSvg />
                        </span> :
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                            <XMarkSvg />
                        </span>}
                </TableCell>
                <TableCell key={`ar-${index}-ModifiedByUser`} style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '9%', padding: '4px 8px', maxWidth: '120px' }}>
                    <Tooltip title={`${item.ModifiedByUser}`}
                        PopperProps={{
                            sx: {
                                "& .MuiTooltip-tooltip": {
                                    backgroundColor: '#DAEDFE',
                                    color: "#000",
                                    minHeight: '26px',
                                    display: 'flex',
                                    fontWeight: '400',
                                    alignItems: "center",
                                    marginTop: '5px !important',
                                    fontSize: '12px'
                                }
                            }
                        }}
                        placement="bottom-start">
                        <span style={{ width: '', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline' }}>
                            {item.ModifiedByUser}
                        </span>
                    </Tooltip>

                </TableCell>
                <TableCell key={`ar-${index}-date`} style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '9%', padding: '4px 8px' }}> {moment(item.ModifiedDateTime).format("HH:mm, DD-MMM-YY")} </TableCell>
                <TableCell key={`ar-${index}-editBtn`} style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '4%', padding: '4px 8px' }}>
                    <span id={`editBtn-${index}`} tabIndex={0} style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold', width: '52px', padding: '2px 4px', marginLeft: '-6px' }}
                        onClick={() => {
                            setEditData(item)
                            updateModal(true, mdt.UpdateAutoReceivePopupModal)
                        }}
                        onKeyDown={(e) => {
                            navigation3(e, index === filteredData?.length - 1 ? 'arNewAutoRecv' : `editBtn-${index + 1}`, index === 0 ? 'arNewAutoRecv' : `editBtn-${index - 1}`,
                                () => {
                                    setEditData(item)
                                    updateModal(true, mdt.UpdateAutoReceivePopupModal)
                                })
                        }
                        }
                    >
                        <EditIcon sx={{ marginRight: '3px' }} />
                        Edit
                    </span>
                </TableCell>
            </TableRow>
        )
    }

    const showAutoRecvModal = () => {
        const data = {
            editData: {},
            isEdit: false,
            mdt: mdt,
            headerText: 'Create Auto Receive Configuration',
            branchList: branchList,
            userList: userList,
            cityList: cityList,
            daysList: daysList,
            hoursList: hoursList,
            minsList: minsList,
            setIsSuccess: setIsSuccess,
            setMessage: setMessage,
            getTableData: getTableData
        }
        return <AutoReceiveModal dataValue={data} updateModal={updateModal} />
    }
    const showUpdateAutoRecvModal = () => {
        const data = {
            editData: editData,
            isEdit: true,
            mdt: mdt,
            headerText: 'Edit Auto Receive Configuration',
            branchList: branchList,
            userList: userList,
            cityList: cityList,
            daysList: daysList,
            hoursList: hoursList,
            minsList: minsList,
            setIsSuccess: setIsSuccess,
            setMessage: setMessage,
            getTableData: getTableData
        }
        return <AutoReceiveModal dataValue={data} updateModal={updateModal} />
    }
    return (
        <>
            <Stack style={{ padding: '11px 0px' }}>
                <Button
                    id="arNewAutoRecv"
                    style={{ margin: '0', height: "40px", width: '300px' }}
                    className="btn add-btn"
                    variant="contained"
                    color="error"
                    onKeyDown={(e) => navigation1(e, `editBtn-0`, `editBtn-${filteredData?.length - 1}`)}
                    onClick={() => {
                        updateModal(true, mdt.AutoReceivePopupModal)
                    }}
                // onClick={(e) => { setIsSuccess(true) }}
                >
                    + create new auto receive
                </Button></Stack>
            <Stack style={{ maxHeight: '60vh', marginTop: '7px' }}>
                <TableContainer className="lr-popup-table lrModel  scrollBlue" style={{ border: '1px solid #ddd', borderBottomLeftRadius: '0px' }} component={Paper}>
                    <Table style={{ border: "none", overflow: 'auto' }} stickyHeader id="focApprovalTbl" className="table1 table-Received " size="small" aria-label="a dense table">
                        <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
                            <TableRow key='AR-tbl-header-one' style={{ background: '#d9edff' }}>
                                {columnDefs.map((col, index) =>
                                    <TableCell key={`AR-TH-${index}`} style={{ ...col.headerSx, padding: '5px 8px', verticalAlign: 'top', backgroundColor: '#DAEDFE', minHeight: '36px', fontFamily: 'Roboto', fontSize: '12px', fontWeight: '600', color: '#444444' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: "space-between" }}>
                                            {col.headerName.split('\n').map((line, lineIndex) => (
                                                <span key={`line-${lineIndex}`} style={{}}>{line}</span>
                                            ))}
                                        </div>
                                    </TableCell>
                                )}
                            </TableRow>
                            <TableRow key='AR-tbl-header-two'>
                                {columnDefs.map((col, index) => col.showfilter ?
                                    <TableCell key={`FTH-${index}`} style={{ padding: '6px 6px' }}>
                                        <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                            <input
                                                id={`contains-${index}`}
                                                className="field"
                                                name="cancelSearchInput"
                                                style={{ width: '100%', paddingTop: '6px', paddingBottom: '6px', height: '24px' }}
                                                placeholder="Contains"
                                                onKeyDown={(e) => navigation1(e, index === 8 ? `contains-1` : index === 6 ? `contains-8` : `contains-${index + 1}`, index === 1 ? `contains-8` : index === 8 || index === 7 ? `contains-6` : `contains-${index - 1}`)}

                                                onChange={(e) => handleChangeContain(e, col.field)}
                                            />
                                            <FilterAltIcon style={{ color: '#AAA' }} />
                                        </div>
                                    </TableCell>
                                    : <TableCell key={`empty-cell-${col.headerName}`}></TableCell>)}
                            </TableRow>
                        </TableHead>
                        {
                            filteredData?.length > 0 ?
                                <>
                                    <TableBody className="filter-data-row" style={{ border: "none" }}>
                                        {filteredData?.map((item, index) => (
                                            <AutoReceiveRow item={item} index={index} key={index} />
                                        ))}
                                    </TableBody>
                                </> :
                                <>
                                    <TableBody>
                                        <EmptyTableRow />
                                    </TableBody>
                                </>
                        }
                    </Table>
                </TableContainer>
            </Stack>
            {showModal && mdt.AutoReceivePopupModal === modalType ? showAutoRecvModal() : null}
            {showModal && mdt.UpdateAutoReceivePopupModal === modalType ? showUpdateAutoRecvModal() : null}
            <SuccessAndErrorModal handleClose={() => { setIsSuccess(false); }} open={isSuccess} title={message} modalStyle={modalStyle} />
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
    updateModal, getAutoReceiveTableData, getOwnChildBranches, getOwnChildUsers, getCompCityList, autoReceiveDataInsertUpdate
}
export default connect(mapStateToProps, mapDispatchToProps)(AutoReceiveTable)
